import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { ImageEditorComponent } from '../image-editor/image-editor.component';

@Component({
  selector: 'app-new-image-decompression',
  templateUrl: './new-image-decompression.component.html',
  styleUrls: ['./new-image-decompression.component.css']
})
export class NewImageDecompressionComponent extends GeneralExerciseComponent {

  @ViewChild('imageEditor', {static:true}) imageEditor: ImageEditorComponent;

  compressedText: string;
  image: string[][];
  highlight: boolean;
  errors: number[][] = [];

  colors: string = "bw";
  position: number[];
  current: number[] =[0,0];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration(){
    this.compressedText = this.configuration.typespecifics.compressedText;
    this.highlight = this.configuration.typespecifics.highlight;
    if(this.compressedText.includes("w")){
      this.colors = "bw";
    } else {
      this.colors = "cmyrgb"
    }

    this.position = [];
    let counts = this.compressedText.split(/([0-9]+)/);
    let presum = 0;
    for(let i = 0; i < counts.length; i++){
      if(Number.isNaN(+counts[i])){
        this.position.push(presum);
      } else {
        presum += +counts[i];
        for(let j = 0; j < counts[i].length; j++){
          this.position.push(presum);
        }
      }
    }
    this.imageEditor.initImage(true);

    this.printable = true;
  }

  setTypeSpecificsFromState(){
    if (this.state.typespecific) {
      if (this.state.typespecific.image) {
        this.image = this.state.typespecific.image;
        this.imageEditor.setImage(this.image);
      }
    }
  }

  computeState() {
    this.state.typespecific.image = this.imageEditor.getImage();
  }

  checkSolution(){
    let counts = this.compressedText.split(/([0-9]+)/);
    let solution = "";

    for (let i = 1; i < counts.length; i += 2) {
      solution = solution.concat(counts[i + 1].repeat(+counts[i]));
    }

    this.image = this.imageEditor.getImage();

    let temp_error = this.image.map((v,i) => (v.map((u,j) => [u,i,j]).filter(u => u[0] != solution.charAt(+u[1]*20 + +u[2])).map(u => [u[1], u[2]])));
    this.errors = [].concat(...temp_error);
    console.log(this.errors);
    if(this.errors.length > 0){
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved=true;
      this.saveState();
    }
  }


  evaluate(): number[] {
    let counts = this.compressedText.split(/([0-9]+)/);
    let solution = "";
    this.image = this.imageEditor.getImage();

    for (let i = 1; i < counts.length; i += 2) {
      solution = solution.concat(counts[i + 1].repeat(+counts[i]));
    }

    let temp_error = this.image.map((v,i) => (v.map((u,j) => [u,i,j]).filter(u => u[0] != solution.charAt(+u[1]*20 + +u[2])).map(u => [u[1], u[2]])));
    let errors = [].concat(...temp_error);
    return [(400-errors.length)/400*5,5];
  }

  /** is the given pixel currently selected? */
  inCurrent(i: number):boolean{
    let pixel = this.current[0] *20 + this.current[1];
    let pos = this.position[i];
    if(this.position[i] > pixel){
      while(this.position[i] == pos){
        i--;
      }
      if(i < 0 || this.position[i] <= pixel){
        return true;
      }
    }
    return false;
  }

  /** finish the exercise if current state is okay */
  autoFill(){
    let filled = 0;


    //compute solution
    let solution = "";
    let counts = this.compressedText.split(/([0-9]+)/);

    for (let i = 1; i < counts.length; i += 2) {
      solution = solution.concat(counts[i + 1].repeat(+counts[i]));
    }


    // check if there is an error in the solved parts
    this.image = this.imageEditor.getImage();
    let baseColor = this.colors=='bw'?'w':"c";
    this.errors = [].concat(...this.image.map((v,i) => (v.map((u,j) => [u,i,j]).filter(u => u[0] != solution.charAt(+u[1]*20 + +u[2]) && u[0] != baseColor).map(u => [u[1], u[2]]))));

    if(this.errors.length > 0){
      this.messageService.addAlertWithTimeout(this.get("errorInSolved"), "danger", 10000);
      return;
    }

    // count the correctly filled pixels
    let filledPixels = this.image.map((v,i) => (v.map((u,j) => [u,i,j]).filter(u => u[0] == solution.charAt(+u[1]*20 + +u[2]) && u[0] != baseColor)));
    filledPixels = [].concat(...filledPixels);
    let notCyanPixels = solution.split("").map((v,i) => v != baseColor);
    filled = 1.0*filledPixels.length / notCyanPixels.length;
    console.log(filled)

    if(filled < 0.3){
      this.messageService.addAlertWithTimeout(this.get("solveMore"), "info", 10000);
      return;
    } else /* if enough is correctly solved*/ {
      this.imageEditor.setImage(solution.match(/.{1,20}/g).map(v => v.split("")));
    }


  }

  
 
}
